import { createContext, Dispatch, SetStateAction } from 'react'

import { FilterValue } from 'components/Filter'
import { CommonFormContextProps } from 'components/Form'

export type DomainListContextType = CommonFormContextProps & {
  filters: FilterValue[]
  setFilters: Dispatch<SetStateAction<FilterValue[]>>
}

export const DomainListContext = createContext<DomainListContextType>({} as DomainListContextType)
